import { TractorFieldNames } from '@contracts/order/fields/TractorInformationFields';
import {
  BooleanField,
  PositiveFloatField,
} from '@src/permitField/PermitFields';

export class TractorLegalWeight extends BooleanField {
  public static fieldName: string = TractorFieldNames.TractorLegalWeight;
}

export class TractorWidthField extends PositiveFloatField {
  public static fieldName: string = TractorFieldNames.TractorWidth;
}

export class TractorHeightField extends PositiveFloatField {
  public static fieldName: string = TractorFieldNames.TractorHeight;
}

export class TractorLengthField extends PositiveFloatField {
  public static fieldName: string = TractorFieldNames.TractorLength;
}

export class TractorWheelBaseField extends PositiveFloatField {
  public static fieldName: string = TractorFieldNames.TractorWheelBase;
}

export class TractorGroundHeightField extends PositiveFloatField {
  public static fieldName: string = TractorFieldNames.TractorGroundHeight;
}

export class TractorUnladenWeightField extends PositiveFloatField {
  public static fieldName: string = TractorFieldNames.TractorUnladenWeight;
}

export class TractorActualWeightField extends PositiveFloatField {
  public static fieldName: string = TractorFieldNames.TractorActualWeight;
}

export class TractorGVWField extends PositiveFloatField {
  public static fieldName: string = TractorFieldNames.TractorGVW;
}

export class TractorOuterBridgeLengthField extends PositiveFloatField {
  public static fieldName: string = TractorFieldNames.TractorOuterBridgeLength;
}

export const tractorDimensionsFields = {
  [TractorLegalWeight.fieldName]: TractorLegalWeight.validator,
  [TractorLengthField.fieldName]: TractorLengthField.validator,
  [TractorGroundHeightField.fieldName]: TractorGroundHeightField.validator,
  [TractorWheelBaseField.fieldName]: TractorWheelBaseField.validator,
  [TractorWidthField.fieldName]: TractorWidthField.validator,
  [TractorHeightField.fieldName]: TractorHeightField.validator,
  [TractorUnladenWeightField.fieldName]: TractorUnladenWeightField.validator,
  [TractorActualWeightField.fieldName]: TractorActualWeightField.validator,
  [TractorGVWField.fieldName]: TractorGVWField.validator,
  [TractorOuterBridgeLengthField.fieldName]:
    TractorOuterBridgeLengthField.validator,
};
